import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const focusVisibleFn = /* @__PURE__ */ createRecipe('focus-visible', {}, [])

const focusVisibleVariantMap = {}

const focusVisibleVariantKeys = Object.keys(focusVisibleVariantMap)

export const focusVisible = /* @__PURE__ */ Object.assign(memo(focusVisibleFn.recipeFn), {
  __recipe__: true,
  __name__: 'focusVisible',
  __getCompoundVariantCss__: focusVisibleFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: focusVisibleVariantKeys,
  variantMap: focusVisibleVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, focusVisibleVariantKeys)
  },
  getVariantProps: focusVisibleFn.getVariantProps,
})